// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .buttonTmplContent .buttonTmplContentBox {
  float: left;
  color: #333;
  border-radius: 12px;
  padding: 0;
  font-size: 14px;
  -webkit-animation: message-left ease-in-out 2s forwards;
  -moz-animation: message-left ease-in-out 2s forwards;
  animation: message-left ease-in-out 2s forwards;
  margin: 0;
  border: 1px solid var(--sdk-chat-widow-primary-bg-color);
  max-width: 95%;
  line-height: 1.5;
}
.kore-chat-window .buttonTmplContent .buttonTmplContentBox .btn-li {
  width: 100%;
  display: inline-block;
  word-break: break-word;
}

.kore-chat-window .buttonTmplContent .buttonTmplContentHeading {
  text-align: left;
  color: var(--sdk-chat-window-bot-bubble-font-clr);
  background: var(--sdk-chat-window-bot-bubble-bg);
  margin: 0 !important;
  padding: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.kore-chat-window .buttonTmplContent .buttonTmplContentHeading .btn-li {
  width: 100%;
  display: inline-block;
  word-break: break-word;
}

.kore-chat-window .buttonTmplContent .buttonTmplContentChild {
  color: var(--sdk-chat-window-btn-font-clr);
  border-top: 1px solid var(--sdk-chat-widow-primary-bg-color);
  padding: 10px;
  margin: 0;
  text-align: center;
  cursor: pointer;
  background-color: var(--sdk-chat-window-btn-default-bg);
}

.kore-chat-window .buttonTmplContent .buttonTmplContentBox a {
  display: inline-block;
  width: 100%;
}

.kore-chat-window .buttonTmplContent .buttonTmplContentHeading .isLink a {
  color: var(--sdk-chat-window-btn-link-color) !important;
  width: auto;
}

.kore-chat-window .buttonTmplContent .buttonTmplContentChild:hover {
  color: var(--sdk-chat-window-btn-hover-font-clr);
  /* border-color: var(--sdk-chat-window-btn-hover-border-clr); */
  background-color: var(--sdk-chat-window-btn-hover-bg);
}

.kore-chat-window .buttonTmplContent .buttonTmplContentHeading img {
  max-width: 100%;
  height: auto;
  padding-top: 5px;
}

[dir=rtl].kore-chat-window .buttonTmplContent .buttonTmplContentBox {
  float: right;
}

[dir=rtl].kore-chat-window .buttonTmplContent .buttonTmplContentHeading {
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/button/buttonTemplate.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;EACA,uDAAA;EACA,oDAAA;EACA,+CAAA;EACA,SAAA;EACA,wDAAA;EACA,cAAA;EACA,gBAAA;AACJ;AAAI;EACI,WAAA;EACA,qBAAA;EACA,sBAAA;AAER;;AAEA;EACI,gBAAA;EACA,iDAAA;EACA,gDAAA;EACA,oBAAA;EACA,aAAA;EACA,4BAAA;EACA,6BAAA;AACJ;AAAI;EACI,WAAA;EACA,qBAAA;EACA,sBAAA;AAER;;AAIA;EACI,0CAAA;EACA,4DAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,uDAAA;AADJ;;AAGA;EACI,qBAAA;EACA,WAAA;AAAJ;;AAEA;EACI,uDAAA;EACA,WAAA;AACJ;;AACA;EACI,gDAAA;EACA,+DAAA;EACA,qDAAA;AAEJ;;AACA;EACI,eAAA;EACA,YAAA;EACA,gBAAA;AAEJ;;AACA;EACI,YAAA;AAEJ;;AAAA;EACI,iBAAA;AAGJ","sourcesContent":[".kore-chat-window .buttonTmplContent .buttonTmplContentBox {\n    float: left;\n    color: #333;\n    border-radius: 12px;\n    padding: 0;\n    font-size: 14px;\n    -webkit-animation: message-left ease-in-out 2s forwards;\n    -moz-animation: message-left ease-in-out 2s forwards;\n    animation: message-left ease-in-out 2s forwards;\n    margin: 0;\n    border: 1px solid var(--sdk-chat-widow-primary-bg-color);\n    max-width: 95%;\n    line-height: 1.5;\n    .btn-li{\n        width: 100%;\n        display: inline-block;\n        word-break: break-word;\n    }\n}\n\n.kore-chat-window .buttonTmplContent .buttonTmplContentHeading {\n    text-align: left;\n    color: var(--sdk-chat-window-bot-bubble-font-clr);\n    background: var(--sdk-chat-window-bot-bubble-bg);\n    margin: 0!important;\n    padding: 10px;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    .btn-li{\n        width: 100%;\n        display: inline-block;\n        word-break: break-word;\n    }\n}\n\n\n\n.kore-chat-window .buttonTmplContent .buttonTmplContentChild {\n    color: var(--sdk-chat-window-btn-font-clr);\n    border-top: 1px solid var(--sdk-chat-widow-primary-bg-color);\n    padding: 10px;\n    margin: 0;\n    text-align: center;\n    cursor: pointer;\n    background-color: var(--sdk-chat-window-btn-default-bg);\n}\n.kore-chat-window .buttonTmplContent .buttonTmplContentBox a {\n    display: inline-block;\n    width: 100%;\n}\n.kore-chat-window .buttonTmplContent .buttonTmplContentHeading .isLink a {\n    color: var(--sdk-chat-window-btn-link-color) !important;\n    width: auto;\n}\n.kore-chat-window .buttonTmplContent .buttonTmplContentChild:hover{\n    color: var(--sdk-chat-window-btn-hover-font-clr);\n    /* border-color: var(--sdk-chat-window-btn-hover-border-clr); */\n    background-color: var(--sdk-chat-window-btn-hover-bg);\n}\n\n.kore-chat-window .buttonTmplContent .buttonTmplContentHeading img{\n    max-width: 100%;\n    height: auto;\n    padding-top: 5px;\n}\n\n[dir=\"rtl\"].kore-chat-window .buttonTmplContent .buttonTmplContentBox{\n    float:right;\n}\n[dir=\"rtl\"].kore-chat-window .buttonTmplContent .buttonTmplContentHeading{\n    text-align: right;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
